export interface IProfileDataDto {
    email: string;
    phoneNumber: string;
    firstName?: string;
    lastName?: string;
    streetAddress?: string;
    postalCode?: string;
    hasLoginCredentials: boolean;
    userName?: string;
    iOrderBankPostAsPaperPost?: boolean;
}

export interface AMLRiskAssesmentClassDto {
    codeId?: number;
    codeText?: string;
    calculatedRisk?: number;
}

export enum AmlRiskAssesmentStatusType {
    None,
    Optional,
    Required,
}

export interface AmlRiskAssesmentStatus {
    amlRiskAssesmentStatusType: AmlRiskAssesmentStatusType;
    latestAnswerDate?: Date;
    nextAnswerDate?: Date;
}



// WEBPACK FOOTER //
// ./src/util/DTOs/ProfileDtos.ts